import * as Types from "../constants/App";
import { ViewState } from "redux/constants/App";

const initialState = {
  viewportWidth: null,
  headerFixed: false,
  headerCoordinates: {
    top: 0,
    left: 0,
    width: 0,
  },
  reloadTable: false,
  searchSentence: null,
  params: {},
  miscs: null,
  getMiscsStatus: ViewState.IDLE,
  summaryPayload: null,
  searcherHeader: "",
};

const actions = {
  [Types.TOGGLE_HEADER_FIXED]: (state, payload) => ({
    ...state,
    headerFixed: payload,
  }),
  [Types.SET_HEADER_COORDINATES]: (state, payload) => ({
    ...state,
    headerCoordinates: payload,
  }),
  [Types.SET_SEARCH_SENTENCE]: (state, payload) => ({
    ...state,
    searchSentence: payload,
  }),
  [Types.UPDATE_VIEWPORT_WIDTH]: (state, payload) => ({
    ...state,
    viewportWidth: payload,
  }),
  [Types.RELOAD_TABLE]: (state) => ({
    ...state,
    reloadTable: !state.reloadTable,
  }),
  [Types.SET_QUERY_PARAMS]: (state, payload) => ({
    ...state,
    params: payload,
  }),
  [Types.SET_TABLE_MISCS]: (state, payload) => ({
    ...state,
    miscs: payload,
  }),
  [Types.SET_TABLE_MISCS_STATUS]: (state, payload) => ({
    ...state,
    getMiscsStatus: payload,
  }),
  [Types.SET_SUMMARY_PAYLOAD]: (state, payload) => ({
    ...state,
    summaryPayload: payload,
  }),
  [Types.SET_SEARCHER_HEADER]: (state, payload) => ({
    ...state,
    searcherHeader: payload,
  }),
};

export default function (state = initialState, { type: actionType, payload }) {
  const action = actions[actionType];
  if (action) return action(state, payload);
  return state;
}
